/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title }) {
    const { site, image } = useStaticQuery(
        graphql`{
  site {
    siteMetadata {
      title
      description
      author
      imageType
      imageWidth
      imageHeight
      video
      videoType
      videoWidth
      videoHeight
      url
    }
  }
  image: file(relativePath: {eq: "pd10preview.png"}) {
    childImageSharp {
      gatsbyImageData(height: 608, width: 1080, placeholder: BLURRED, layout: FIXED)
    }
  }
}
`
    )

    const metaDescription = description || site.siteMetadata.description

    return (
        <Helmet
            htmlAttributes={{
                lang
            }}
            title={title}
            titleTemplate={`${site.siteMetadata.title} | %s`}
            meta={[
                {
                    name: `description`,
                    content: metaDescription
                },
                {
                    property: `og:title`,
                    content: `PD10 x KC | ${title}`
                },
                {
                    property: `og:url`,
                    content: site.siteMetadata.urlh
                },
                {
                    property: `og:description`,
                    content: metaDescription
                },
                {
                    property: `og:type`,
                    content: `website`
                },
                {
                    name: `twitter:card`,
                    content: `summary`
                },
                {
                    name: `twitter:creator`,
                    content: site.siteMetadata.author
                },
                {
                    name: `twitter:title`,
                    content: title
                },
                {
                    name: `twitter:description`,
                    content: metaDescription
                },
                {
                    property: `og:image`,
                    content: site.siteMetadata.url.concat(
                        image.childImageSharp.gatsbyImageData.src
                    )
                },
                {
                    property: `og:image:type`,
                    content: site.siteMetadata.imageType
                },
                {
                    property: `og:image:width`,
                    content: site.siteMetadata.imageWidth
                },
                {
                    property: `og:image:height`,
                    content: site.siteMetadata.imageHeight
                },
                {
                    property: `og:video`,
                    content: site.siteMetadata.video
                },
                {
                    property: `og:video:secure_url`,
                    content: site.siteMetadata.video
                },
                {
                    property: `og:video:type`,
                    content: site.siteMetadata.videoType
                },
                {
                    property: `og:video:width`,
                    content: site.siteMetadata.videoWidth
                },
                {
                    property: `og:video:height`,
                    content: site.siteMetadata.videoHeight
                }
            ].concat(meta)}
        ></Helmet>
    );
}

SEO.defaultProps = {
    lang: `en`,
    meta: [],
    description: ``
}

export default SEO
